
//import errorHandler from './errorHandler'
import api from '../../../api'
import qs from 'query-string'
import _ from 'lodash'

export default {
    get : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.get('/api/v1/pagestatistics' + queryString, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    getMessageCount : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.get('/api/v1/messages/.getCountByPages' + queryString, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    getConversationCountByPage : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.get('/api/v1/conversations/.getCountByPages' + queryString, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    getConversationCount : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.head('/api/v1/conversations' + queryString, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    getDirectMessageCount : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.head('/api/v1/conversations' + queryString, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    getPositiveMessageCount : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.head('/api/v1/conversations' + queryString, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    getNegativeMessageCount : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.head('/api/v1/conversations' + queryString, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    getNeutralMessageCount : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.head('/api/v1/conversations' + queryString, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
/*     getCommentCount : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.head('/api/v1/conversations' + queryString + '&notTagId=5eb7304806846b3b928e05d9', (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    }, */
    getCommentCount : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.head('/api/v1/conversations' + queryString, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    getAdConversationCount : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.head('/api/v1/conversations' + queryString, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    getTagsCount : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.get('/api/v1/messages/.getTagCountByPages' + queryString, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    getAverageResponseTime : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.get('/api/v1/messages/.getFirstTimeResponse' + queryString, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    getCountByPagesAndPlatforms : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.get('/api/v1/messages/.getCountByPagesAndPlatforms' + queryString, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    getAudincesByPages : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.get('/api/v1/messages/.getAudincesByPages' + queryString, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    getUserStatistics : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.get('/api/v1/userstatistics' + queryString, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    getUserStatisticsByWorkspaceUserId : (payload, next) => {
        let queryString = '';
        if(payload.query) queryString = '?'+qs.stringify(payload.query);
        api.get('/api/v1/workspaceusers/' + payload.params.workspaceUserId + '.getStatistics' + queryString, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    }
} 



// WEBPACK FOOTER //
// ./src/libs/system/services/statistics.js